import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useGetUserQuery } from 'common';
import { getMemberName } from '../../utils';
const wrapperCss = "wns5ea8";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const textWrapperCss = "t8nf75b";
const TextWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textWrapperCss, props.className)} />;
});
export const DisplayOrganizer = ({
  kind,
  currentOrganizer
}) => {
  const {
    data: currentUser
  } = useGetUserQuery();
  return <Wrapper>
      <TextWrapper>
        <BodyText>
          {I18n.t(`publisher.event_type_editor.sections.event_details.location.inlines.${kind}.header`)}
          :
        </BodyText>
      </TextWrapper>
      <BodyText>{getMemberName(currentOrganizer, currentUser)}</BodyText>
    </Wrapper>;
};

require("./display_organizer.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./display_organizer.js");